/*=========================================================================================
  File Name: modulePostActions.js
  Description: Post Module Actions
==========================================================================================*/

import postGQL from "@/http/requests/inside/post_gql";

export default {
	getPosts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			postGQL
				.getPosts(payload)
				.then(response => {
					commit("SET_POSTS", response.posts.data);
					commit("SET_TOTAL_POSTS", response.posts.total);
					commit("SET_IS_HAS_MORE_PAGES", response.posts.has_more_pages);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addPost({ state, commit }, post) {
		return new Promise((resolve, reject) => {
			postGQL
				.addPost(post)
				.then(response => {
					commit("ADD_POST", response);
					commit("SET_TOTAL_POSTS", state.total + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updatePost({ commit }, post) {
		return new Promise((resolve, reject) => {
			postGQL
				.updatePost(post)
				.then(response => {
					commit("UPDATE_POST", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deletePost({ state, commit }, postId) {
		return new Promise((resolve, reject) => {
			postGQL
				.deletePost(postId)
				.then(response => {
					commit("DELETE_POST", postId);
					commit("SET_TOTAL_POSTS", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	toggleLikePost({ commit }, postId) {
		return new Promise((resolve, reject) => {
			postGQL
				.toggleLikePost(postId)
				.then(response => {
					commit("TOGGLE_LIKE_POST", postId);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getAppellations({ commit }) {
		return new Promise((resolve, reject) => {
			postGQL
				.getAppellations()
				.then(response => {
					commit("SET_APPELLATIONS", response.appellations);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getFeaturePosts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			postGQL
				.getPosts(payload)
				.then(response => {
					commit("SET_FEATURE_POSTS", response.posts.data);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
